import { useTranslation } from '@klv/hooks/useTranslation';

import marketing from './static/marketing.webp';

import  type { Layout } from 'gatsby-plugin-image';

const useSolutionContent = () => {
  const { t } = useTranslation();

  const rowContent = [{
    id: 'marketing',
    //translation dynamically combiled in pills component
    pills: ['Email marketing', 'Mobile Push', 'Reviews', 'Sms marketing', 'Customer hub', 'Benchmarks', 'Reporting', 'Profiles', 'Integrations', 'Klaviyo AI'],
    headline: t('organisms_solutionsScrollAccordion_row_headline_1'),
    subhead: t('organisms_solutionsScrollAccordion_row_subhead_1'),
    button: t('organisms_solutionsScrollAccordion_row_button_1'),
    href: t('organisms_solutionsScrollAccordion_row_href_1'),
    rive: {
      riveFile: '/static/rive/solutions-accordion-scroll/marketing.riv',
      riveText: [
        { key: 'Klaviyo AI',	value: t('organisms_solutionsScrollAccordion_row_rive_1_klaviyoAI') },
        { key: 'Create with AI',	value: t('organisms_solutionsScrollAccordion_row_rive_1_createWithAI') },          
        { key: 'Describe flow',	value: t('organisms_solutionsScrollAccordion_row_rive_1_describeFlow') },            
        { key: 'Input message',	value: t('organisms_solutionsScrollAccordion_row_rive_1_whenSomeoneViewsAProductAndDoesNotBuySendAnSMS') },            
        { key: 'Generate draft',	value: t('organisms_solutionsScrollAccordion_row_rive_1_generateDraft') },            
        { key: 'Flow trigger',	value: t('organisms_solutionsScrollAccordion_row_rive_1_flowTrigger') },           
        { key: 'Has viewed product',	value: t('organisms_solutionsScrollAccordion_row_rive_1_hasViewedProduct') },           
        { key: 'Consented to receive SMS?',	value: t('organisms_solutionsScrollAccordion_row_rive_1_consentedToReceiveSMS') },         
        { key: 'No',	value: t('organisms_solutionsScrollAccordion_row_rive_1_no') },     
        { key: 'Yes',	value: t('organisms_solutionsScrollAccordion_row_rive_1_yes') },            
        { key: 'View abandoned product',	value: t('organisms_solutionsScrollAccordion_row_rive_1_viewAbandonedProduct') },           
        { key: 'SMS A/B test',	value: t('organisms_solutionsScrollAccordion_row_rive_1_smsABTest') },         
        { key: 'A',	value: t('organisms_solutionsScrollAccordion_row_rive_1_a') },      
        { key: 'B',	value: t('organisms_solutionsScrollAccordion_row_rive_1_b') },            
        { key: 'Message 1',	value: t('organisms_solutionsScrollAccordion_row_rive_1_weLoveThatYouLoveThisDontLeaveItBehindClickToShop') },            
        { key: '43.2%',	value: t('organisms_solutionsScrollAccordion_row_rive_1_43Percent') },            
        { key: 'Message 2',	value: t('organisms_solutionsScrollAccordion_row_rive_1_dontLeaveItBehind') },            
        { key: 'Click rate',	value: t('organisms_solutionsScrollAccordion_row_rive_1_clickRate') },
        { key: '27.2%',	value: t('organisms_solutionsScrollAccordion_row_rive_1_27Percent') },
      ],
      aspectRatio: '424/340',
    },
    media: {
      altText: '"',
      gatsbyImage: {
        layout: 'fullWidth' as Layout,
        images: {
          fallback: {
            src: marketing,
          },
        },
        width: 1050,
        height: 748,
      },
    },
    exploreTitle: t('organisms_solutionsScrollAccordion_row_explore_title_1'),
    explore: [
      {
        button: t('organisms_solutionsScrollAccordion_row_explore_arr_1_button_a'),
        href: t('organisms_solutionsScrollAccordion_row_explore_arr_1_href_a'),
      }, {
        button: t('organisms_solutionsScrollAccordion_row_explore_arr_1_button_b'),
        href: t('organisms_solutionsScrollAccordion_row_explore_arr_1_href_b'),
      }, {
        button: t('organisms_solutionsScrollAccordion_row_explore_arr_1_button_c'),
        href: t('organisms_solutionsScrollAccordion_row_explore_arr_1_href_c'),
      }, {
        button: t('organisms_solutionsScrollAccordion_row_explore_arr_1_button_d'),
        href: t('organisms_solutionsScrollAccordion_row_explore_arr_1_href_d'),
      }, {
        button: t('organisms_solutionsScrollAccordion_row_explore_arr_1_button_e'),
        href: t('organisms_solutionsScrollAccordion_row_explore_arr_1_href_e'),
      }, {
        button: t('organisms_solutionsScrollAccordion_row_explore_arr_1_button_f'),
        href: t('organisms_solutionsScrollAccordion_row_explore_arr_1_href_f'),
      }, {
        button: t('organisms_solutionsScrollAccordion_row_explore_arr_1_button_g'),
        href: t('organisms_solutionsScrollAccordion_row_explore_arr_1_href_g'),
      }],
  }, {
    id: 'support',
    pills: [],
    headline: t('organisms_solutionsScrollAccordion_row_headline_3'),
    subhead: t('organisms_solutionsScrollAccordion_row_subhead_3'),
    button: t('organisms_solutionsScrollAccordion_row_button_3'),
    href: t('organisms_solutionsScrollAccordion_row_href_3'),
    rive: {
      riveFile: '/static/rive/solutions-accordion-scroll/service.riv',
      riveText: [
        { key: 'Find a store', value: t('organisms_solutionsScrollAccordion_row_rive_3_findAStore') },
        { key: 'Help', value: t('organisms_solutionsScrollAccordion_row_rive_3_help') },
        { key: 'New', value: t('organisms_solutionsScrollAccordion_row_rive_3_new') },
        { key: 'Shoes', value: t('organisms_solutionsScrollAccordion_row_rive_3_shoes') },
        { key: 'Clothing', value: t('organisms_solutionsScrollAccordion_row_rive_3_clothing') },
        { key: 'Accessories', value: t('organisms_solutionsScrollAccordion_row_rive_3_accessories') },
        { key: 'Members: Free shipping on orders $50+', value: t('organisms_solutionsScrollAccordion_row_rive_3_membersFreeShippingOnOrdersFiftyPlus') },
        { key: 'Horizon Ribbed Training Set', value: t('organisms_solutionsScrollAccordion_row_rive_3_horizonRibbedTrainingSet') },
        { key: 'Dash item cost', value: t('organisms_solutionsScrollAccordion_row_rive_3_twoHundredTen') },
        { key: 'Color', value: t('organisms_solutionsScrollAccordion_row_rive_3_color') },
        { key: 'Coral', value: t('organisms_solutionsScrollAccordion_row_rive_3_coral') },
        { key: 'Sky', value: t('organisms_solutionsScrollAccordion_row_rive_3_sky') },
        { key: 'Maroon', value: t('organisms_solutionsScrollAccordion_row_rive_3_maroon') },
        { key: 'Select size', value: t('organisms_solutionsScrollAccordion_row_rive_3_selectSize') },
        { key: 'XS', value: t('organisms_solutionsScrollAccordion_row_rive_3_xs') },
        { key: 'L', value: t('organisms_solutionsScrollAccordion_row_rive_3_l') },
        { key: 'XL', value: t('organisms_solutionsScrollAccordion_row_rive_3_xl') },
        { key: 'XXL', value: t('organisms_solutionsScrollAccordion_row_rive_3_xxl') },
        { key: 'Add to bag', value: t('organisms_solutionsScrollAccordion_row_rive_3_addToBag') },
        { key: 'Welcome, Mia', value: t('organisms_solutionsScrollAccordion_row_rive_3_welcomeMia') },
        { key: 'Arriving today', value: t('organisms_solutionsScrollAccordion_row_rive_3_arrivingToday') },
        { key: 'Recently viewed', value: t('organisms_solutionsScrollAccordion_row_rive_3_recentlyViewed') },
        { key: 'Item title', value: t('organisms_solutionsScrollAccordion_row_rive_3_featherweightRunningShoes') },
        { key: 'Item price', value: t('organisms_solutionsScrollAccordion_row_rive_3_thirtyFivePointNinetyNine') },
        { key: 'Add to cart', value: t('organisms_solutionsScrollAccordion_row_rive_3_addToCart') },
        { key: 'For you', value: t('organisms_solutionsScrollAccordion_row_rive_3_forYou') },
        { key: 'Orders', value: t('organisms_solutionsScrollAccordion_row_rive_3_orders') },
        { key: 'Chat', value: t('organisms_solutionsScrollAccordion_row_rive_3_chat') },
        { key: 'Profile', value: t('organisms_solutionsScrollAccordion_row_rive_3_profile') },
        { key: 'Chat', value: t('organisms_solutionsScrollAccordion_row_rive_3_chat') },
        { key: 'Text message 1', value: t('organisms_solutionsScrollAccordion_row_rive_3_myOrderJustArrivedAndItLooksLikeIWasShippedTheWrongSizeShoes') },
        { key: 'Text message 2', value: t('organisms_solutionsScrollAccordion_row_rive_3_pleaseHoldForAMomentWhileWeConnectYouWithAnAgent') },
        { key: 'Say something', value: t('organisms_solutionsScrollAccordion_row_rive_3_saySomething') },
        { key: 'Unified Inbox', value: t('organisms_solutionsScrollAccordion_row_rive_3_unifiedInbox') },
        { key: 'Mia Williams', value: t('organisms_solutionsScrollAccordion_row_rive_3_miaWilliams') },
        { key: 'Message 1', value: t('organisms_solutionsScrollAccordion_row_rive_3_myOrderJustArrivedAndItLooksLikeIWasShippedARedTankTopWhenIOrderedATealOne') },
        { key: 'Mia Williams', value: t('organisms_solutionsScrollAccordion_row_rive_3_miaWilliams') },
        { key: 'mia.williams@abc.com', value: t('organisms_solutionsScrollAccordion_row_rive_3_miaWilliamsAtAbcDotCom') },
        { key: 'Phone number', value: t('organisms_solutionsScrollAccordion_row_rive_3_plusOneOneTwoThreeFourFiveSixSevenEightNineZero') },
        { key: 'Orders', value: t('organisms_solutionsScrollAccordion_row_rive_3_orders') },
        { key: 'Activity', value: t('organisms_solutionsScrollAccordion_row_rive_3_activity') },
        { key: 'Unified Inbox', value: t('organisms_solutionsScrollAccordion_row_rive_3_unifiedInbox') },
        { key: 'Mia Williams', value: t('organisms_solutionsScrollAccordion_row_rive_3_miaWilliams') },
        { key: 'Message 1', value: t('organisms_solutionsScrollAccordion_row_rive_3_myOrderJustArrivedAndItLooksLikeIWasShippedARedTankTopWhenIOrderedATealOne') },
        { key: 'Sean H.', value: t('organisms_solutionsScrollAccordion_row_rive_3_seanH') },
        { key: 'Message 2', value: t('organisms_solutionsScrollAccordion_row_rive_3_sorryAboutThatMiaWellGetTheCorrectColorShippedOutToday') },
        { key: 'Mia Williams', value: t('organisms_solutionsScrollAccordion_row_rive_3_miaWilliams') },
        { key: 'mia.williams@abc.com', value: t('organisms_solutionsScrollAccordion_row_rive_3_miaWilliamsAtAbcDotCom') },
        { key: 'Phone number', value: t('organisms_solutionsScrollAccordion_row_rive_3_plusOneOneTwoThreeFourFiveSixSevenEightNineZero') },
        { key: 'Orders', value: t('organisms_solutionsScrollAccordion_row_rive_3_orders') },
        { key: 'Activity', value: t('organisms_solutionsScrollAccordion_row_rive_3_activity') },
        { key: 'Unified Inbox', value: t('organisms_solutionsScrollAccordion_row_rive_3_unifiedInbox') },
        { key: 'Mia Williams', value: t('organisms_solutionsScrollAccordion_row_rive_3_miaWilliams') },
        { key: 'Message 1', value: t('organisms_solutionsScrollAccordion_row_rive_3_myOrderJustArrivedAndItLooksLikeIWasShippedARedTankTopWhenIOrderedATealOne') },
        { key: 'Sean H.', value: t('organisms_solutionsScrollAccordion_row_rive_3_seanH') },
        { key: 'Message 2', value: t('organisms_solutionsScrollAccordion_row_rive_3_sorryAboutThatMiaWellGetTheCorrectColorShippedOutToday') },
        { key: 'Mia Williams', value: t('organisms_solutionsScrollAccordion_row_rive_3_miaWilliams') },
        { key: 'mia.williams@abc.com', value: t('organisms_solutionsScrollAccordion_row_rive_3_miaWilliamsAtAbcDotCom') },
        { key: 'Phone number', value: t('organisms_solutionsScrollAccordion_row_rive_3_phoneNumber') },
        { key: 'Orders', value: t('organisms_solutionsScrollAccordion_row_rive_3_orders') },
        { key: 'Activity', value: t('organisms_solutionsScrollAccordion_row_rive_3_activity') },
        { key: 'Message 3', value: t('organisms_solutionsScrollAccordion_row_rive_3_yesThatsMyOrderThanksForYourHelp') },
      ],
      aspectRatio: '424/340',
    },
    media: {
      altText: '"',
      gatsbyImage: {
        layout: 'fullWidth' as Layout,
        images: {
          fallback: {
            src: marketing,
          },
        },
        width: 1050,
        height: 748,
      },
    },    exploreTitle: t('organisms_solutionsScrollAccordion_row_explore_title_3'),
    explore: [
      {
        button: t('organisms_solutionsScrollAccordion_row_explore_arr_3_button_a'),
        href: t('organisms_solutionsScrollAccordion_row_explore_arr_3_href_a'),
      },
    ],
  }, {
    id: 'analytics',
    pills: [],
    headline: t('organisms_solutionsScrollAccordion_row_headline_2'),
    subhead: t('organisms_solutionsScrollAccordion_row_subhead_2'),
    button: t('organisms_solutionsScrollAccordion_row_button_2'),
    href: t('organisms_solutionsScrollAccordion_row_href_2'),
    rive: {
      riveFile: '/static/rive/solutions-accordion-scroll/analytics.riv',
      riveText: [
        { key: 'Segment growth report',	value: t('organisms_solutionsScrollAccordion_row_rive_2_segmentGrowthReport') },	
        { key: 'Total members',	value: t('organisms_solutionsScrollAccordion_row_rive_2_totalMembers') },
        { key: '3%',	value: t('organisms_solutionsScrollAccordion_row_rive_2_threePercent') },
        { key: 'Members added',	value: t('organisms_solutionsScrollAccordion_row_rive_2_membersAdded') },
        { key: 'Members dropped',	value: t('organisms_solutionsScrollAccordion_row_rive_2_membersDropped') },
        { key: 'Champions',	value: t('organisms_solutionsScrollAccordion_row_rive_2_champions') },
        { key: '43,619',	value: t('organisms_solutionsScrollAccordion_row_rive_2_fortyThreeThousandSixHundredNineteen') },
        { key: '1,513',	value: t('organisms_solutionsScrollAccordion_row_rive_2_oneThousandFiveHundredThirteen') },
        { key: '452',	value: t('organisms_solutionsScrollAccordion_row_rive_2_fourHundredFiftyTwo') },
        { key: 'Flow trigger',	value: t('organisms_solutionsScrollAccordion_row_rive_2_flowTrigger') },
        { key: 'RFM group is Champion',	value: t('organisms_solutionsScrollAccordion_row_rive_2_rfmGroupIsChampion') },
        { key: 'No',	value: t('organisms_solutionsScrollAccordion_row_rive_2_no') },
        { key: 'Yes',	value: t('organisms_solutionsScrollAccordion_row_rive_2_yes') },
        { key: 'Exclusive offer',	value: t('organisms_solutionsScrollAccordion_row_rive_2_exclusiveOffer') },
        { key: 'Champions flow',	value: t('organisms_solutionsScrollAccordion_row_rive_2_championsFlow') },	
        { key: 'Click rate',	value: t('organisms_solutionsScrollAccordion_row_rive_2_clickRate') },
        { key: 'Conversion rate',	value: t('organisms_solutionsScrollAccordion_row_rive_2_conversionRate') },
        { key: '7.50%',	value: t('organisms_solutionsScrollAccordion_row_rive_2_sevenPointFiveZeroPercent') },
        { key: '5.20%',	value: t('organisms_solutionsScrollAccordion_row_rive_2_fivePointTwoZeroPercent') },
        { key: 'Excellent',	value: t('organisms_solutionsScrollAccordion_row_rive_2_excellent') },
        { key: 'Excellent',	value: t('organisms_solutionsScrollAccordion_row_rive_2_excellent') },
        { key: 'Conversion overview',	value: t('organisms_solutionsScrollAccordion_row_rive_2_conversionOverview') },
        { key: 'Revenue',	value: t('organisms_solutionsScrollAccordion_row_rive_2_revenue') },
        { key: 'Revenue number',	value: t('organisms_solutionsScrollAccordion_row_rive_2_revenueNumber') },	
        { key: 'Attributed revenue',	value: t('organisms_solutionsScrollAccordion_row_rive_2_attributedRevenue') },	
        { key: 'Attributed revenue number',	value: t('organisms_solutionsScrollAccordion_row_rive_2_attributedRevenueNumber') },	
        { key: '8%',	value: t('organisms_solutionsScrollAccordion_row_rive_2_eightPercent') },	
        { key: 'Month 1',	value: t('organisms_solutionsScrollAccordion_row_rive_2_monthOne') },
        { key: 'Month 2',	value: t('organisms_solutionsScrollAccordion_row_rive_2_monthTwo') },
      ],
      aspectRatio: '424/340',
    },
    media: {
      altText: '"',
      gatsbyImage: {
        layout: 'fullWidth' as Layout,
        images: {
          fallback: {
            src: marketing,
          },
        },
        width: 1050,
        height: 748,
      },
    },    exploreTitle: t('organisms_solutionsScrollAccordion_row_explore_title_2'),
    explore: [
      {
        button: t('organisms_solutionsScrollAccordion_row_explore_arr_2_button_a'),
        href: t('organisms_solutionsScrollAccordion_row_explore_arr_2_href_a'),
      }, {
        button: t('organisms_solutionsScrollAccordion_row_explore_arr_2_button_b'),
        href: t('organisms_solutionsScrollAccordion_row_explore_arr_2_href_b'),
      }, {
        button: t('organisms_solutionsScrollAccordion_row_explore_arr_2_button_c'),
        href: t('organisms_solutionsScrollAccordion_row_explore_arr_2_href_c'),
      },
    ],
  }, {
    id: 'data',
    pills: [],
    headline: t('organisms_solutionsScrollAccordion_row_headline_4'),
    subhead: t('organisms_solutionsScrollAccordion_row_subhead_4'),
    button: t('organisms_solutionsScrollAccordion_row_button_4'),
    href: t('organisms_solutionsScrollAccordion_row_href_4'),
    rive: {
      riveFile: '/static/rive/solutions-accordion-scroll/platform.riv',
      riveText: [
        { key: 'Name',	value: t('organisms_solutionsScrollAccordion_row_rive_4_name') },
        { key: 'email',	value: t('organisms_solutionsScrollAccordion_row_rive_4_email') },
        { key: 'Customer activity',	value: t('organisms_solutionsScrollAccordion_row_rive_4_customerActivity') },	
        { key: 'Left 5-star review',	value: t('organisms_solutionsScrollAccordion_row_rive_4_leftFiveStarReview') },	
        { key: 'Order delivered',	value: t('organisms_solutionsScrollAccordion_row_rive_4_orderDelivered') },	
        { key: 'Order shipped',	value: t('organisms_solutionsScrollAccordion_row_rive_4_orderShipped') },	
        { key: 'Placed order for $206',	value: t('organisms_solutionsScrollAccordion_row_rive_4_placedOrderForTwoHundredSix') },	
        { key: 'Flow trigger',	value: t('organisms_solutionsScrollAccordion_row_rive_4_flowTrigger') },	
        { key: 'Left 5-star review',	value: t('organisms_solutionsScrollAccordion_row_rive_4_leftFiveStarReview') },	
        { key: 'No',	value: t('organisms_solutionsScrollAccordion_row_rive_4_no') },	
        { key: 'Yes',	value: t('organisms_solutionsScrollAccordion_row_rive_4_yes') },	
        { key: 'Discount code',	value: t('organisms_solutionsScrollAccordion_row_rive_4_discountCode') },	
        { key: 'Inbox',	value: t('organisms_solutionsScrollAccordion_row_rive_4_inbox') },	
        { key: 'Thanks for your feedback',	value: t('organisms_solutionsScrollAccordion_row_rive_4_thanksForYourFeedbackEnjoy') },	
        { key: 'Enjoy',	value: t('organisms_solutionsScrollAccordion_row_rive_4_Enjoy') },	
        { key: '10% off',	value: t('organisms_solutionsScrollAccordion_row_rive_4_tenPercentOff') },	
        { key: 'Shop now',	value: t('organisms_solutionsScrollAccordion_row_rive_4_shopNow') },	
        { key: 'Opened email discount',	value: t('organisms_solutionsScrollAccordion_row_rive_4_openedEmailDiscount') },
      ],
      aspectRatio: '424/340',
    },
    media: {
      altText: '"',
      gatsbyImage: {
        layout: 'fullWidth' as Layout,
        images: {
          fallback: {
            src: marketing,
          },
        },
        width: 1050,
        height: 748,
      },
    },    exploreTitle: t('organisms_solutionsScrollAccordion_row_explore_title_4'),
    explore: [
      {
        button: t('organisms_solutionsScrollAccordion_row_explore_arr_4_button_a'),
        href: t('organisms_solutionsScrollAccordion_row_explore_arr_4_href_a'),
      }, {
        button: t('organisms_solutionsScrollAccordion_row_explore_arr_4_button_b'),
        href: t('organisms_solutionsScrollAccordion_row_explore_arr_4_href_b'),
      }, {
        button: t('organisms_solutionsScrollAccordion_row_explore_arr_4_button_c'),
        href: t('organisms_solutionsScrollAccordion_row_explore_arr_4_href_c'),
      },
      {
        button: t('organisms_solutionsScrollAccordion_row_explore_arr_4_button_d'),
        href: t('organisms_solutionsScrollAccordion_row_explore_arr_4_href_d'),
      },
    ],
  }];

  const data = {
    rowContent,
  };

  return data;
};

export default useSolutionContent;
